<template>
  <a-modal class="modal-content" :width="650" :visible="visible" :footer="null" @cancel="hideModal">
    <div slot="title" style="font-size: 18px; font-weight: bold; color: #333">
      {{ title }}
    </div>
    <div class="container">
      <div class="row" v-for="(item, index) in recordList" :key="index">
        <div class="key">{{ item.key }}</div>
        <div style="flex: 1">{{ item.value }}</div>
      </div>
      <div
        style="padding: 10px 0; margin-left: 15px; color: #1783e8; font-weight: bold"
        @click="downloadFile"
      >
        家校园沟通记录表.doc 下载
      </div>
    </div>
  </a-modal>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { downloadFile, getStoreFileUrl } from '@/utils/util'
import JMultiSelectTag from '@comp/dict/JMultiSelectTag.vue'

export default {
  name: 'TeacherAssessment',
  components: { JMultiSelectTag },
  mixins: [JeecgListMixin],
  props: {
    title: {
      type: String,
      default: '班主任评估记录',
    },
  },
  data() {
    return {
      visible: false,
      templateUrl: getStoreFileUrl('/schoolEvaluation/中小学心理评估访谈提纲记录表.docx'),
      recordList: [
        {
          key: '班级表现',
          value: '人际关系不良',
        },
        {
          key: '家庭情况',
          value: '人际关系不良',
        },
        {
          key: '备注',
          value: '',
        },
      ],
      // uploadAction: window._CONFIG['domianURL'] + '/sys/common/upload?biz=studentTag',
      uploadAction: window._CONFIG['domianURL'] + '/sys/common/upload?biz=emotionComments',
    }
  },
  methods: {
    showModal(data, index) {
      // this.recordList = data
      this.visible = true
    },
    hideModal() {
      this.visible = false
    },
    downloadFile(item) {
      downloadFile(item.file, item.title)
    },
  },
}
</script>
<style scoped lang="less">
.container {
  font-size: 16px;
  .row {
    display: flex;
    padding: 10px 0;
    .key {
      display: inline-block;
      width: 80px;
      margin-right: 15px;
      text-align: right;
      color: #333333;
      font-weight: bold;
    }
  }
}
</style>
